import PropTypes from 'prop-types';
import React from 'react';
import Helmet from 'react-helmet';
import favicon from '../assets/images/favicon.png';
import getRandomIconUrl from '../utils/getRandomIconUrl';
export default function DocumentHead(_a) {
    var appIcon = _a.appIcon, projectID = _a.projectID, projectTitle = _a.projectTitle, screenName = _a.screenName, statusBar = _a.statusBar, viewportFitCover = _a.viewportFitCover;
    var metas = getMetaTags(statusBar, viewportFitCover);
    var links = getIconLinks(projectID, appIcon);
    // Add favicon
    links.push({
        href: favicon,
        rel: 'shortcut icon',
        type: 'image/png',
    });
    var title = screenName ? "".concat(projectTitle, " \u2013 ").concat(screenName) : projectTitle;
    return React.createElement(Helmet, { link: links, meta: metas, title: title, titleTemplate: "%s" });
}
DocumentHead.propTypes = {
    projectID: PropTypes.string.isRequired,
    projectTitle: PropTypes.string.isRequired,
    appIcon: PropTypes.string,
    statusBar: PropTypes.object.isRequired,
    viewportFitCover: PropTypes.bool.isRequired,
};
function getIconLinks(projectID, appIcon) {
    var href;
    if (appIcon) {
        href = appIcon;
    }
    else {
        href = getRandomIconUrl(projectID);
    }
    return [
        {
            href: href,
            rel: 'apple-touch-icon',
        },
        {
            href: href,
            rel: 'icon',
        },
    ];
}
function getMetaTags(statusBar, viewportFitCover) {
    var viewportContent = [
        'width=device-width',
        'initial-scale=1.0',
        'maximum-scale=1.0',
        'user-scalable=no',
    ];
    if (viewportFitCover) {
        viewportContent.push('viewport-fit=cover');
    }
    return [
        {
            name: 'viewport',
            content: viewportContent.join(', '),
        },
        {
            name: 'apple-mobile-web-app-status-bar-style',
            content: statusBar.appleStatusBarStyle,
        },
    ];
}
